import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/features'),
      component: SettingsWrapper,
      props: {
        headerTitle: 'FEATURES_SETTINGS.TITLE',
        icon: 'i-lucide-toggle-right',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'features_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
